import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Form from "react-bootstrap/Form";
import { useForm } from "react-hook-form";
import { Button, Row } from "react-bootstrap";
import { instructorActions, UserActions } from "../../../redux/actions";
import { useDispatch } from "react-redux";
import { globalConstants, translationConstants } from "../../../constants";
import { getSportDataForDropdown } from "../../../system";

import InputFieldWrapper from "../InputFieldWrapper/InputFieldWrapper";
import CertificateDetails from "./CertificateDetails";

const ApprovedCertificate = ({
  fileDetails,
  userID,
  userEmail,
  isInstructor,
  gridState,
}) => {
  const {
    setValue,
    trigger,
    reset,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [levelOptions, setLevelOptions] = useState([]);
  const [proficiencyLevelOptions, setProficiencyLevelOptions] = useState([]);

  // Set initial level options based on fileDetails
  useEffect(() => {
    if (fileDetails) {
      const levelOptions = getSportDataForDropdown(
        t,
        fileDetails?.sportId,
        fileDetails?.boatTypeId
      );
      setLevelOptions(levelOptions);
      reset({
        levelId: "", // Reset the selected levelId
        proficiencyLevelId: "", // Reset proficiency level
        comment: "", // Reset comment field
      });
    }
  }, [fileDetails, reset, t]);

  const onSubmit = (data) => {
    const status = {
      status: 0,
      sportLevelId: fileDetails.id,
      levelId: data.levelId,
      proficiencyLevelId: data.proficiencyLevelId
        ? data.proficiencyLevelId
        : null,
      comments: data.comment,
    };

    const documentStatus = {
      userId: userID,
      userEmail: userEmail,
      documentStatuses: [status],
    };

    dispatch(UserActions.OpenAppRejModal(false));
    if (isInstructor) {
      dispatch(
        instructorActions.approveInstructorDocuments(
          documentStatus,
          gridState,
          userID
        )
      );
    } else {
      dispatch(
        UserActions.approvedCertificate(documentStatus, gridState, userID)
      );
    }
  };

  return (
    <div>
      <div className="ViewHeader">
        <p className="viewUserPara">
          {t(translationConstants.APPROVE_CERTIFICATE)}
        </p>
      </div>
      <p className="horizentalLine" />
      <CertificateDetails fileDetails={fileDetails} />
      <Form
        className="approvalCertificateDiv"
        onSubmit={handleSubmit(onSubmit)}
      >
        <Row>
          <InputFieldWrapper
            label={
              `${t(translationConstants.ASSIGN_A_LEVEL)}:` +
              globalConstants.Mandatory_Character
            }
          >
            <Form.Select
              id="levelId"
              {...register("levelId", {
                required: t(translationConstants.levelSelectionRequired),
              })}
              onChange={(event) => {
                setProficiencyLevelOptions(
                  getSportDataForDropdown(
                    t,
                    fileDetails?.sportId,
                    fileDetails?.boatTypeId,
                    event.target.value
                  )
                );
                setValue("levelId", event.target.value);
                trigger("levelId");
              }}
            >
              <option value="">{t(translationConstants.SELECT_LEVEL)}</option>
              {levelOptions.map((object) => (
                <option key={object.value} value={object.value}>
                  {t(translationConstants[object.label])}
                </option>
              ))}
            </Form.Select>
            {errors?.levelId && (
              <p className="errorText">{errors?.levelId.message}</p>
            )}
          </InputFieldWrapper>
          {!isInstructor && (
            <InputFieldWrapper
              label={
                `${t(translationConstants.ASSIGN_PROFICIENCY_LEVEL)}:` +
                globalConstants.Mandatory_Character
              }
            >
              <Form.Select
                id="proficiencyLevelId"
                {...register("proficiencyLevelId", {
                  required: t(
                    translationConstants.SUGGESTED_PROFICIENCY_LEVEL_REQUIRED
                  ),
                })}
                onChange={(event) => {
                  setValue("proficiencyLevelId", event.target.value);
                  trigger("proficiencyLevelId");
                }}
              >
                <option value="">
                  {t(translationConstants.SELECT_PROFICIENCY_LEVEL)}
                </option>
                {proficiencyLevelOptions.map((object) => (
                  <option key={object.value} value={object.value}>
                    {t(translationConstants[object.label])}
                  </option>
                ))}
              </Form.Select>
              {errors?.proficiencyLevelId && (
                <p className="errorText">
                  {errors?.proficiencyLevelId.message}
                </p>
              )}
            </InputFieldWrapper>
          )}
        </Row>
        <Form.Group className="form-group formgroupTextarea">
          <Form.Label className="Form-labels">
            {t(translationConstants.comments)}
          </Form.Label>
          <textarea
            className="commentInput"
            id="comment"
            type="text"
            {...register("comment")}
          />
          {errors.comment && (
            <p className="errorText">{errors.comment.message}</p>
          )}
        </Form.Group>
        <Button className="approved-button" type="submit">
          {t(translationConstants.Approve)}
        </Button>
      </Form>
    </div>
  );
};

export default ApprovedCertificate;
